import { deepAddParent as K } from "@project-rouge/rg-core";
import { useThree as N } from "@react-three/fiber";
import { useMemo as t, useRef as W, useEffect as X, Fragment as Y } from "react";
import { Vector3 as V, Mesh as Z, BoxGeometry as q } from "three";
import { RgView as b } from "../../3d/rg-render-types/index4.js";
import { useFunction as G } from "../../hooks/index2.js";
import { FitToFrame as nn } from "../../utils/index11.js";
import { StandardRenderLayers as en } from "../../utils/index27.js";
import { hashRgObj as on } from "../../utils/rg-util/index5.js";
import { dispose as tn } from "../../utils/three/index.js";
import { BuildingFcLayer as rn } from "./index3.js";
import { ChildrenToMerge as sn, MergeBuildingChildrenFC as cn } from "./index4.js";
import { jsx as O, Fragment as an, jsxs as pn } from "react/jsx-runtime";
const gn = ({
  building: c,
  visibility: d,
  focus: P,
  orbit: l,
  layers: a = en,
  onClick: r,
  onContextMenu: p,
  onDoubleClick: m,
  onPointerUp: e,
  onPointerDown: w,
  onPointerOver: h,
  onPointerOut: M,
  onPointerEnter: C,
  onPointerLeave: x,
  onPointerMove: y,
  onPointerCancel: _,
  colourFunc: k
}) => {
  const {
    camera: z,
    invalidate: Q
  } = N();
  t(() => {
    K(c);
  }, [c]);
  const g = t(() => c.children.filter((n) => !sn.includes(n.type)), [c]), $ = t(() => {
    const n = /* @__PURE__ */ new Map();
    for (const o of g) {
      if (o.hash || (o.hash = on(o)), n.get(o.hash))
        continue;
      const f = new b({
        ...o,
        pos: [0, 0, 0],
        rot: [0, 0, 0]
      });
      n.set(o.hash, f);
    }
    return n;
  }, [g]), i = W({
    onClick: /* @__PURE__ */ new Map(),
    onContextMenu: /* @__PURE__ */ new Map(),
    onDoubleClick: /* @__PURE__ */ new Map(),
    onPointerUp: /* @__PURE__ */ new Map(),
    onPointerDown: /* @__PURE__ */ new Map(),
    onPointerOver: /* @__PURE__ */ new Map(),
    onPointerOut: /* @__PURE__ */ new Map(),
    onPointerEnter: /* @__PURE__ */ new Map(),
    onPointerLeave: /* @__PURE__ */ new Map(),
    onPointerMove: /* @__PURE__ */ new Map(),
    onPointerCancel: /* @__PURE__ */ new Map()
  }), D = t(() => r ? (n) => s(n, r, i.current.onClick) : void 0, [r]), E = t(() => p ? (n) => s(n, p, i.current.onContextMenu) : void 0, [p]), B = t(() => m ? (n) => s(n, m, i.current.onDoubleClick) : void 0, [m]), I = t(() => e ? (n) => s(n, e, i.current.onPointerUp) : void 0, [e]), L = t(() => w ? (n) => s(n, w, i.current.onPointerDown) : void 0, [w]), S = t(() => h ? (n) => s(n, h, i.current.onPointerOver) : void 0, [h]), T = t(() => M ? (n) => s(n, M, i.current.onPointerOut) : void 0, [M]), j = t(() => C ? (n) => s(n, C, i.current.onPointerEnter) : void 0, [C]), R = t(() => x ? (n) => s(n, x, i.current.onPointerLeave) : void 0, [x]), U = t(() => y ? (n) => s(n, y, i.current.onPointerMove) : void 0, [y]), A = t(() => _ ? (n) => s(n, _, i.current.onPointerCancel) : void 0, [_]), s = G((n, o, f) => {
    const u = n.event.timeStamp;
    let v = f.get(u);
    v || (v = [], f.set(u, v)), v.push(n), H({
      timeStamp: u,
      queueMap: f,
      handler: o
    });
  }), H = G(({
    timeStamp: n,
    queueMap: o,
    handler: f
  }) => {
    setTimeout(() => {
      const F = o.get(n);
      if (!F)
        return;
      o.delete(n);
      const u = F.sort((v, J) => v.event.distance - J.event.distance)[0];
      u.event.timeStamp = Date.now(), f(u);
    }, 0);
  });
  return X(() => {
    !l || !P || z.isPerspectiveCamera && mn({
      building: c,
      orbit: l,
      camera: z,
      invalidate: Q
    });
  }, [P, c, d, l]), /* @__PURE__ */ O(an, {
    children: Array.from(a).map(([n, o]) => /* @__PURE__ */ pn(Y, {
      children: [/* @__PURE__ */ O(rn, {
        buildingChildren: g,
        layerID: n,
        layer: o,
        visibility: d,
        views: $,
        onClick: D,
        onContextMenu: E,
        onDoubleClick: B,
        onPointerUp: I,
        onPointerDown: L,
        onPointerOver: S,
        onPointerOut: T,
        onPointerEnter: j,
        onPointerLeave: R,
        onPointerMove: U,
        onPointerCancel: A,
        colourFunc: k
      }), /* @__PURE__ */ O(cn, {
        building: c,
        layer: o,
        visibility: d,
        onClick: D,
        onContextMenu: E,
        onDoubleClick: B,
        onPointerUp: I,
        onPointerDown: L,
        onPointerOver: S,
        onPointerOut: T,
        onPointerEnter: j,
        onPointerLeave: R,
        onPointerMove: U,
        onPointerCancel: A,
        colourFunc: k
      })]
    }, n))
  });
};
function mn({
  building: c,
  orbit: d,
  camera: P,
  invalidate: l
}) {
  const a = new V(1 / 0, 1 / 0, 1 / 0), r = new V(-1 / 0, -1 / 0, -1 / 0);
  for (const e of c.children)
    e.pos[0] < a.x && (a.x = e.pos[0]), e.pos[1] < a.y && (a.y = e.pos[1]), e.pos[2] < a.z && (a.z = e.pos[2]), e.pos[0] > r.x && (r.x = e.pos[0]), e.pos[1] > r.y && (r.y = e.pos[1]), e.pos[2] > r.z && (r.z = e.pos[2]);
  const p = r.clone().sub(a), m = new Z(new q(p.x, p.y, p.z));
  m.position.add(p.clone().multiplyScalar(0.5)), m.scale.setScalar(1.5), nn({
    target: m,
    orbit: d,
    camera: P,
    invalidate: l
  }).then(() => {
    tn(m);
  });
}
export {
  gn as BuildingFC
};
//# sourceMappingURL=index2.js.map
